import React from "react";
import { Link } from "react-router-dom";
import * as S from "./style";

const MobileMenu = () => {
  return (
    <S.MenuContainer>
      <Link to="/menu-categorias" state={{ origin: window.location.pathname }}>
        <i className="fas fa-bars"></i> CATEGORIAS
      </Link>
    </S.MenuContainer>
  );
};

export default MobileMenu;
